import copyToClipboard from 'copy-to-clipboard';

function callback(e, setNotification) {
  copyToClipboard(`${e.latLng.lat},${e.latLng.lng}`);
  setNotification({
    message: 'LatLon copied to clipboard',
    impact: 'positive',
    autoDismiss: 2,
  });
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function ({ options, setNotification }) {
  return {
    text: options.text,
    callback: (e) => callback(e, setNotification),
  };
}
